const BaseComponent = require('base/base-component');

class goTop extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .gotop-box': 'gotopEvent'
      }
    });
  }

  init () {
    this.$container = this.$el.find('.gotop-box');
    this.flag = true;
    let that = this;
    let t;
    $(window).on('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const _scrollTop = $(document).scrollTop();
        if (_scrollTop > 1) {
          that.$container.slideDown('fast', () => { that.flag = false; });
        } else if (_scrollTop <= 1) {
          that.$container.slideUp('fast', () => { that.flag = true; });
        }
      }, 50);
    });
  }

  gotopEvent () {
    $('html , body').animate({ scrollTop: 0 }, 300);
  }
}
module.exports = goTop;
